import IcEur from './IcEur'

export default IcEur
